import { PaymentSessionContextType } from '@/context/PaymentSessionContext';
import { UseMutationResult } from '@tanstack/react-query';
import { createContext, useContext } from 'react';
import { DeletePaymentSessionResponse, PostPaymentSession, PostPaymentSessionResponse } from './types';
import { FetchError } from '@/hooks/useApi';

export const PaymentSessionContext = createContext<PaymentSessionContextType>({
  isLoading: false,
  isFetching: false,
  queryError: null,
  paymentSession: undefined,
  postPaymentSession: {} as UseMutationResult<PostPaymentSessionResponse, FetchError, PostPaymentSession, unknown>,
  cancelPaymentSession: {} as UseMutationResult<DeletePaymentSessionResponse, FetchError, string, unknown>,
  partialPayment: {
    enabled: false,
    amount: '',
    amountNumberInCents: 0,
    amountPrice: '',
    setEnabled: () => {},
    setAmount: () => {}
  },
  setPaymentSessionId: () => {},
  resetPaymentSession: () => {}
});

export const usePaymentSession = () => {
  const context = useContext(PaymentSessionContext);

  vtlog('usePaymentSession:', context);

  if (context === null) {
    throw new Error('usePaymentSession must be used within a PaymentSessionProvider');
  }

  return context;
};
